export const APP_URLS = {
  WEBSITE: "https://mahal.qa",
  ADMIN: "https://admin.mahal.qa",
  SUPPLIER: "https://supplier.mahal.qa",
  CUSTOMER: "https://customer.mahal.qa",
};